import { Component, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { AutocompleteDataSourceFn, MgAutocompleteComponent, MgAutocompleteData } from '@mango/core';
import { Relatie } from 'src/app/core/dto/relatie';
import { RelatieService } from 'src/app/core/service/relatie.service';

export interface InstrumentRelatieDialogData {
    relatie: Relatie;
}

@Component({
    selector: 'c-i-j-borculo-instrumentrelatie',
    templateUrl: './instrumentrelatie.component.html',
    styleUrls: ['./instrumentrelatie.component.css']
})
export class InstrumentRelatieComponent {
    
    @ViewChild('relatieAutocomplete') instrumentAutocomplete: MgAutocompleteComponent;
    @ViewChild('savebutton') savebutton: HTMLButtonElement;

    RelatieFormGroup: FormGroup;
	getRelatieDataSource: AutocompleteDataSourceFn<Relatie> = MgAutocompleteData.empty();
    isDisabled: boolean = true;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: InstrumentRelatieDialogData,
        private dialogRef: MatDialogRef<InstrumentRelatieComponent>,
        private service: RelatieService,
        private fb: FormBuilder)        
    {

    }    

    ngOnInit() {
    
        this.RelatieFormGroup = this.fb.group({
			relatie: this.fb.control(null, null)
		});

        this.getRelatieDataSource = MgAutocompleteData.complex<Relatie>(this.service, null).text('naam1', 'postPlaats', 'verzendPlaats').number('oldID').datasource();
    
    }

	relatieDisplayFn(relatie: Relatie) {
        return `${relatie.oldID} - ${relatie.naam1 } - ${relatie.postPlaats } - ${relatie.verzendPlaats }`;
	}  
            
    Ok(){
        // Relatie is geselecteerd
        let { relatie } = this.RelatieFormGroup.value;

        this.dialogRef.close({data: relatie});
    }   

}
